<template>
  <div>
    <Header headerStyle="main" :go="go" :fixed-header="fixedHeader" />
    <div class="main">
      <div id="service" class="section">
        <div class="service-slide">
          <carousel
            :per-page="1"
            :autoplay="true"
            :autoplayTimeout="7000"
            :mouseDrag="false"
            :navigationEnabled="true"
            :navigationClickTargetSize="22"
          >
            <slide
                data-index="0"
                data-name="MySlideName">
              <div class="VueCarousel-contents">
                <div class="VueCarousel-title">
                  Giftiel,<br />
                  전할수록 즐거운<br />
                  롯데 모바일 상품권
                </div>
                <div class="VueCarousel-description">
                  언제 어디서나 전할 수 있는 선물, 전할수록 즐거운 선물!<br />
                  기프티엘에서 소중한 마음을 전하세요.
                </div>
              </div>
              <img src="@/assets/images/main-visual.jpg" alt="">
            </slide>
          </carousel>
        </div>
      </div>
      <div id="brand" class="section">
        <div class="section__inner">
          <h2 class="section__title">브랜드</h2>
          <div class="brand">
            <div class="brand__list">
              <img src="@/assets/images/brand-logo01.png" alt="" class="brand__image">
              <div class="brand__title">
                롯데리아
              </div>
            </div>
            <div class="brand__list">
              <img src="@/assets/images/brand-logo02.png" alt="" class="brand__image">
              <div class="brand__title">
                크리스피크림
              </div>
            </div>
            <div class="brand__list">
              <img src="@/assets/images/brand-logo03.png" alt="" class="brand__image" id="logo03">
              <div class="brand__title">
                엔제리너스 커피
              </div>
            </div>
            <div class="brand__list">
              <img src="@/assets/images/brand-logo04.png" alt="" class="brand__image">
              <div class="brand__title">
                나뚜루
              </div>
            </div>
            <div class="brand__list">
              <img src="@/assets/images/brand-logo05-1.png" alt="" id="logo05">
              <div class="brand__title2">
                롯데모바일상품권
              </div>
            </div>
            <div class="brand__list">
              <img src="@/assets/images/brand-logo06.png" alt="" class="brand__image">
              <div class="brand__title">
                유니클로
              </div>
            </div>
            <div class="brand__list">
              <img src="@/assets/images/brand-logo08.png" alt="" class="brand__image">
              <div class="brand__title">
                롯데마트&amp;토이저러스
              </div>
            </div>
            <div class="brand__list">
              <img src="@/assets/images/brand-logo09.png" alt="" class="brand__image">
              <div class="brand__title">
                롯데시네마
              </div>
            </div>
            <div class="brand__list">
              <img src="@/assets/images/brand-logo10.png" alt="" class="brand__image">
              <div class="brand__title">
                하이마트
              </div>
            </div>
            <div class="brand__list">
              <img src="@/assets/images/brand-logo11.png" alt="" id="logo11">
              <div class="brand__title">
                엘포인트
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="guide" class="section section--grey">
       <div class="section__inner">
          <div class="contact">
              <img src="@/assets/images/ico-image.png" class="section img2" alt="">
                <div class="customer__title">
                    <span class="customer__text_info customer__text_info--red">전할수록 즐거운</span><br>
                    <span class="customer__text_info customer__text_info--bold">기업 마케팅 전문 기프티엘 비즈</span>
                    <div class="customer__text_info">
                      기프티엘비즈는 기업 전용 모바일쿠폰 대량발송 서비스입니다.<br>
                      기업에서 진행하는 각종 프로모션/이벤트, 고객관리, 임직원 복지 등<br>
                      모바일쿠폰을 최적으로 활용할 수 있도록 서비스를  제공하고 있습니다 <br>
                      모바일 쿠폰 업계 최초! 등급 조건 없이 구매 수량에 따라 최대 11%할인율을 제공합니다.
                    </div>
                    <a  class = "info info--button" href="https://www.giftielbiz.co.kr/main" target='_blank'>
                      <img  src="@/assets/images/biz-button.png" alt="" class = "section img3" >
                    </a>
                </div>
          </div>
         </div>
      </div>
      <div id="customer" class="section">
        <div class="section__inner">
          <h2 class="section__title">고객지원</h2>
          <div class="box">
              <div class="box__column" style="margin: auto;">
                <div class="customer">
                  <div class="customer__title">
                    고객 문의 &amp; 환불 문의
                  </div>
                  <dl class="customer__dl">
                    <dt class="customer__dt">
                      전화번호
                    </dt>
                    <dd class="customer__dd">
                      <div class="customer__text customer__text--bold">
                        <span class="customer__text customer__text--red">1644</span>-4276
                      </div>
                    </dd>
                    <dt class="customer__dt">
                      문의시간
                    </dt>
                    <dd class="customer__dd customer__dd--phone">
                      <div class="customer__text">
                        월~금 09:30~18:00 (공휴일 제외)
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div id="contact" class="section section--background">
        <div class="section__inner">
          <h2 class="section__title section__title--white">제휴문의</h2>
          <div class="contact">
            <div class="contact__list">
              <span class="contact__icon contact__icon--phone"></span>
              02-3671-6491
            </div>
            <div class="contact__list">
              <span class="contact__icon contact__icon--mail"></span>
                <a href="mailto:giftiel@lotte.net" class="contact__anchor">
                  giftiel@lotte.net
                </a>
            </div>
          </div>
          <div class="card">
            <div class="card__item">
              <div class="card__title">상품입점</div>
              <div class="card__description">
                기프티엘 서비스에 입점하여 모바일 쿠폰 형태를 통한 <br>
                효율적인 판매와 홍보를 시작해보세요.
              </div>
            </div>
            <div class="card__item">
              <div class="card__title">B2B 제휴</div>
              <div class="card__description">
                롯데그룹의 주요 브랜드를 포함한 약 150여개 브랜드, 3천여개의<br>
                상품을 운영합니다.<br>
                기프티엘의 다양한 상품을 이벤트, 프로모션, 고객 관리 등에 편하게<br>
                활용해 보세요.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 팝업 컴포넌트 -->
    <!-- <PopupNotice/> -->
  </div>
</template>

<script>
/* eslint-disable */
import { Carousel, Slide } from 'vue-carousel';
import Header from "@/components/Header";
// import PopupNotice from "@/components/PopupNotice";
import Accordion from '@/components/Accordion';
import PopupNotice from '../components/PopupNotice.vue';

export default {
  name: "Main",
  components: {
    Header,
    PopupNotice,
    Accordion,
    Carousel,
    Slide
  },
  props: {
    section: String
  },
  mounted() {
    this.$nextTick(() => {
      this.bindEvents();
      if (this.section !== undefined) {
        setTimeout(() => window.scrollTo(
          0,
          [...document.querySelectorAll(".section")][this.section].offsetTop
        ));
        // window.dispatchEvent(new Event("scroll"));
      }
    });
  },
  destroyed() {
    this.unbindEvents();
  },
  data() {
    return {
      fixedHeader: false
    };
  },
  methods: {
    bindEvents() {
      window.addEventListener('scroll', this.scrollAction);
    },
    go(e, $target) {
      this.scrollTo(
        document.documentElement,
        document.querySelector($target).offsetTop,
        300
      );
    },
    scrollTo(element, to, duration) {
      if (duration <= 0) return;

      const difference = to - element.scrollTop;
      const perTick = (difference / duration) * 10;

      setTimeout(() => {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        this.scrollTo(element, to, duration - 10);
      }, 10);
    },
    unbindEvents() {
      window.removeEventListener('scroll', this.scrollAction);
    },
    scrollAction() {
      if (document.querySelector('.section') === null) return;

      const $section = document.querySelectorAll('.section');
      const $anchor = document.querySelectorAll('.gnb__anchor');
      const $header = document.querySelector('.header');

      if (window.pageYOffset >= $section[0].offsetHeight - 109) {
        $header.classList.add('scrolled');
        this.fixedHeader = true;
      } else {
        $header.classList.remove('scrolled');
        this.fixedHeader = false;
      }

      if ( this.getScrollPosition($section[0], $section[1]) ) {
        this.active($anchor[0]);
      } else if ( this.getScrollPosition($section[1], $section[2]) ) {
        this.active($anchor[1]);
      } else if ( this.getScrollPosition($section[2], $section[3]) ) {
        this.active($anchor[2]);
      } else if ( this.getScrollPosition($section[3], $section[4]) ) {
        this.active($anchor[3]);
      } else if ( this.getScrollPosition($section[4]) ) {
        this.active($anchor[4]);
      }
    },
    getScrollPosition( $current, $next ) {
      if ( $next !== undefined ) {
        if ( window.pageYOffset >= ($current.offsetTop - 65) && window.pageYOffset < ($next.offsetTop - 65) ) {
          return true;
        } else {
          return false;
        }
      } else {
        if ( window.pageYOffset >= ($current.offsetTop - 65) ) {
          return true;
        } else {
          return false;
        }
      }
    },
    active($target) {
      var anchors = Array.from(document.querySelectorAll('.gnb__anchor'));
      anchors.forEach(el => el.classList.remove('is-active'));
      $target.classList.add('is-active');
    }

  }
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/mixin.scss';
.main {
  font-size: 19px;
}
.section {
  box-sizing: border-box;
  &:not(:first-child) {
    padding: 120px 0 150px;
  }
  &--grey {
    max-height: 960px;
    background-color: #f5f5f5;
  }
  &--background {
    background: url('../assets/images/bg-contact.png') no-repeat center;
    background-size: cover;
  }
  &__inner {
    margin: 0 auto;
    width: 1140px;
  }
  &__title {
    margin-bottom: 70px;
    text-align: center;
    font-size: 42px;
    font-weight: 500;
    color: #222;
    &--white {
      color: #fff;
    }
  }
  img {
    width: 100%;
    display: block;
  }
  .img2 {
    margin-bottom: 10px;
    width: 300px;
    height: 400px;
  }
  .img3 {
    margin-left: 30px;
    margin-top:  40px;
    width: 280px;
    height: 70px;
  }

}
.box {
  border: 1px solid #e6e6e6;
  @include flexbox();
  @include align-items(flex-start);
  &__column {
    padding: 40px;
    width: 50%;
    box-sizing: border-box;
  }
}
.brand {
  margin: 0 -10px;
  @include flexbox();
  @include justify-content(center);
  @include align-items(flex-start);
  @include flex-wrap(wrap);
  &__list {
    margin: 0 10px;
    width: calc( (100% / 5) - 20px );
    &:nth-child(n + 6) {
      margin-top: 70px;
    }
  }
  &__title {
    margin-top: 20px;
    text-align: center;
  }
  &__title2 {
    margin-top: 30px;
    text-align: center;
  }
}
.customer {
  padding-left: 109px;
  position: relative;
  &::before {
    width: 80px;
    height: 80px;
    position: absolute;
    top: 0;
    left: 0;
    background: url('../assets/images/ico-customer.png') no-repeat 0 0;
    content: '';
  }
  &--refund {
    &::before {
      background-position: -80px 0;
    }
  }
  &__title {
    margin-bottom: 30px;
    font-size: 22px;
    font-weight: 500;
    &--flex {
      margin-bottom: 20px;
      @include flexbox();
      @include align-items(center);
      @include justify-content(space-between);
    }
  }
  &__text {
    line-height: 34px;
    font-size: 19px;
    color: #666;
    &--bold {
      font-size: 28px;
      font-weight: 500;
      color: #222;
    }
    &--red {
      font-size: inherit;
      color: #e31d1a;
    }
  }
    &__text_info {
    margin-top: 30px;
    margin-right: 10px;
    line-height: 40px;
    font-size:16px;
    color: #666;
    margin-left: 30px;
    &--bold {
      font-size: 35px;
      font-weight: 500;
      color: #222;
    }
    &--red {
      font-size: 35px;
      color: #e31d1a;
    }
  }
  &__dl {
    margin-top: -10px;
    line-height: 40px;
    @include flexbox();
    @include align-items(center);
    @include flex-wrap(wrap);
  }
  &__dt {
    width: 86px;
    font-size: 19px;
  }
  &__dd {
    width: calc( 100% - 86px );
  }
  &__button {
    width: 123px;
    height: 30px;
    border: 1px solid #666;
    @include flexbox();
    @include align-items(center);
    @include justify-content(center);
    text-decoration: none;
    font-size: 15px;
    color: #222;
  }
}
.contact {
  margin-bottom: 40px;
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  &__list {
    @include flexbox();
    @include align-items(center);
    color: #fff;
    & ~ & {
      margin-left: 48px;
    }
  }
  &__anchor {
    text-decoration: none;
    color: inherit;
  }
  &__icon {
    margin-right: 10px;
    width: 20px;
    height: 20px;
    display: block;
    background: url('../assets/images/ico-contact.png') no-repeat 0 0;
    &--mail {
      background-position: -20px 0;
    }
  }
}
.card {
  margin: 0 -15px;
  border: none;
  border-radius: 0;
  @include flexbox();
  @include flex-direction(row);
  @include justify-content(center);
  background: none;
  color: #fff;
  &__item {
    padding: 40px;
    margin: 0 15px;
    width: calc( (100% / 2) - 100px );
    height: 300px;
    background-color: rgba(255, 255, 255, 0.15);
    box-sizing: border-box;
    @include flexbox();
    @include flex-direction(column);
  }
  &__title {
    font-size: 28px;
    font-weight: 500;
  }
  &__description {
    margin-top: 40px;
    font-size: 15px;
    line-height: 34px;
  }
}
.service-slide {
  position: relative;
  &::after {
    position: absolute;
    left: 50%;
    bottom: 126px;
    transform: translateX(-50%);
    font-size: 15px;
    color: #fff;
    animation-name: scroll;
    animation-duration: 3s;
    animation-delay: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
}

@keyframes scroll {
  0% {
    opacity: 1;
  }
  50% {
    opacity: .3;
  }
  100% {
    opacity: 1;
  }
}

</style>

<style lang='scss'>
.VueCarousel-slide {
  position: relative;
}
.VueCarousel-contents {
  position: absolute;
  top: 230px;
  left: 50%;
  transform: translateX(-50%);
  width: 1140px;
}
.VueCarousel-title {
  margin-top: -14px;
  line-height: 75px;
  font-size: 60px;
  font-weight: 500;
  color: #fff;
  &.black {
    color: #222;
  }
}
.VueCarousel-description {
  margin-top: 33px;
  line-height: 39px;
  font-size: 24px;
  color: #fff;
  &.black {
    color: #222;
  }
}
.VueCarousel-pagination {
  position: absolute;
  left: 50%;
  bottom: 67px;
  transform: translateX(-50%);
  width: 1140px !important;
  text-align: right !important;
}
.VueCarousel-navigation-button {
  margin-left: 0 !important;
  transform: translateY(-50%) !important;
  background: url('../assets/images/ico-carousel-button.png') no-repeat center;
  transition: opacity .3s;
  color: transparent !important;
}
.VueCarousel-navigation-next {
  transform: translateY(-50%) rotate(-180deg) !important;
}
.VueCarousel-navigation--disabled {
  opacity: 0.15 !important;
}
.VueCarousel-dot {
  margin-left: 9px;
  padding: 0 !important;
  border: 2px solid #fff !important;
  background-color: transparent !important;
  width: 8px !important;
  height: 8px !important;
}
.VueCarousel-dot--active {
  background-color: #fff !important;
}
#logo03{
width: 120px;
height: 100.94px;
display : block;
margin : auto;
}
#logo05{
width: 180px;
height: 70px;
display : block;
margin-top: 20px;
}
#logo11{
padding-top: 40px;
width: 180px;
height: 40.94px;
margin : auto;
margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue